__turbopack_context__.v({
  "icon": "VersionStackToggleRow-module__IdrXaq__icon",
  "label": "VersionStackToggleRow-module__IdrXaq__label",
});
